import { PromptMode } from '@loc/server/interface/task'

import { normalizeMusicGeneratorFormValues } from '../_blocks/GeneratorForm/_hooks/normalizeMusicGeneratorFormValues'
import { type BaseUIState, createPageStore } from '../../_shared/formStore'
import { MUSIC_DRAFT_STORAGE_KEY } from '../../_shared/formDraft/draftKeys'

import type { MusicGeneratorFormValuesNew } from '../_types/form'

// ─── Form 默认值 ───
export const MUSIC_FORM_DEFAULTS = normalizeMusicGeneratorFormValues({
  promptTabsMode: 'smart',
  promptSelectMode: PromptMode.SMART,
  styleMode: 'recommend',
  customTaskType: 'Song',
  taskType: 'Song',
  thinking: true,
}) as MusicGeneratorFormValuesNew

/** Rap 页面强制覆盖的默认值 */
export const RAP_FORCED_DEFAULTS: Partial<MusicGeneratorFormValuesNew> = {
  promptTabsMode: 'custom',
  promptSelectMode: PromptMode.SMART,
  customTaskType: 'Song',
  taskType: 'Song',
  Songdescription: 'Rap',
  Instrumentaldescription: 'Rap',
  thinking: true,
}

// ─── Prefs：持久化的偏好 ───
export interface MusicPrefs {
  advancedExpanded: boolean
}

const MUSIC_PREFS_DEFAULTS: MusicPrefs = {
  advancedExpanded: false,
}

// ─── UI：瞬态状态 ───
type MusicUI = BaseUIState

const MUSIC_UI_DEFAULTS: MusicUI = {
  isSubmitting: false,
  isUploading: false,
}

// ─── helpers ───
function getValidImageUrl(imageUrl?: string) {
  return imageUrl?.startsWith('http') ? imageUrl : undefined
}

function sanitizeMusicForm(
  data: Partial<MusicGeneratorFormValuesNew>,
): MusicGeneratorFormValuesNew {
  return normalizeMusicGeneratorFormValues({
    ...MUSIC_FORM_DEFAULTS,
    ...data,
    imageUrl: getValidImageUrl(data.imageUrl),
  }) as MusicGeneratorFormValuesNew
}

// ─── Store 工厂 ───
export function createMusicFormStore(options?: {
  persistKey?: string
  forcedFormDefaults?: Partial<MusicGeneratorFormValuesNew>
}) {
  const persistKey = options?.persistKey ?? MUSIC_DRAFT_STORAGE_KEY
  const forcedFormDefaults = options?.forcedFormDefaults
  const name = forcedFormDefaults ? 'RapFormStore' : 'MusicFormStore'

  return createPageStore<MusicGeneratorFormValuesNew, MusicPrefs, MusicUI>({
    name,
    persistKey,
    formDefaults: MUSIC_FORM_DEFAULTS,
    prefsDefaults: MUSIC_PREFS_DEFAULTS,
    uiDefaults: MUSIC_UI_DEFAULTS,
    forcedFormDefaults,
    sanitizeOnLoad: sanitizeMusicForm,
    pickPersistedFormFields: (form) => ({
      ...form,
      imageUrl: getValidImageUrl(form.imageUrl),
    }),
  })
}
